import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpotify, faApple, faYoutube, faInstagram, faSoundcloud } from "@fortawesome/free-brands-svg-icons";
const SocialHanldes = () => {
  return (
    <>
           {/* Social Media & Streaming Links */}
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex justify-center space-x-4 mt-4">
           <FontAwesomeIcon icon={faSpotify} className="text-green-500 text-3xl hover:text-green-400" />
           <FontAwesomeIcon icon={faApple} className="text-red-500 text-3xl hover:text-red-400" />
           <FontAwesomeIcon icon={faYoutube} className="text-red-600 text-3xl hover:text-red-500" />
           <FontAwesomeIcon icon={faSoundcloud} className="text-orange-500 text-3xl hover:text-orange-400" />
           <FontAwesomeIcon icon={faInstagram} className="text-pink-500 text-3xl hover:text-pink-400" />
        </div>
      </div>
    </>
  );
};

export default SocialHanldes;
